import type { LocalizedNotificationKind, NotificationMessage } from "@dawn/engine";
import type { GameStrings } from "./types.ts";

type GameCopyKey = {
  [K in keyof GameStrings]: GameStrings[K] extends string ? K : never;
}[keyof GameStrings];

export const NOTIFICATION_I18N_KEYS: Record<
  LocalizedNotificationKind,
  { title: GameCopyKey; body: GameCopyKey }
> = {
  swampEnter: { title: "notificationSwampTitle", body: "notificationSwampBody" },
  fireEnter: { title: "notificationFireTitle", body: "notificationFireBody" },
  foodDepletion: {
    title: "notificationFoodDepletionTitle",
    body: "notificationFoodDepletionBody",
  },
  tutorialTurns: {
    title: "notificationTutorialTurnsTitle",
    body: "notificationTutorialTurnsBody",
  },
  tutorialStats: {
    title: "notificationTutorialStatsTitle",
    body: "notificationTutorialStatsBody",
  },
  tutorialWinGoal: {
    title: "notificationTutorialWinGoalTitle",
    body: "notificationTutorialWinGoalBody",
  },
  tutorialFoodEconomy: {
    title: "notificationTutorialFoodEconomyTitle",
    body: "notificationTutorialFoodEconomyBody",
  },
  tutorialTileFood: {
    title: "notificationTutorialTileFoodTitle",
    body: "notificationTutorialTileFoodBody",
  },
  tutorialGrowth: {
    title: "notificationTutorialGrowthTitle",
    body: "notificationTutorialGrowthBody",
  },
  tutorialFamine: {
    title: "notificationTutorialFamineTitle",
    body: "notificationTutorialFamineBody",
  },
  tutorialOneMove: {
    title: "notificationTutorialOneMoveTitle",
    body: "notificationTutorialOneMoveBody",
  },
  tutorialFoodOverlay: {
    title: "notificationTutorialFoodOverlayTitle",
    body: "notificationTutorialFoodOverlayBody",
  },
  tutorialLandRecovery: {
    title: "notificationTutorialLandRecoveryTitle",
    body: "notificationTutorialLandRecoveryBody",
  },
  tutorialSettings: {
    title: "notificationTutorialSettingsTitle",
    body: "notificationTutorialSettingsBody",
  },
  tutorialRandomEvents: {
    title: "notificationTutorialRandomEventsTitle",
    body: "notificationTutorialRandomEventsBody",
  },
};

export function resolveLocalizedNotificationCopy(
  kind: LocalizedNotificationKind,
  strings: GameStrings,
): NotificationMessage {
  const keys = NOTIFICATION_I18N_KEYS[kind];
  return {
    title: strings[keys.title],
    body: strings[keys.body],
  };
}
